import { render, staticRenderFns } from "./TemplatesList.vue?vue&type=template&id=2183d47d&scoped=true"
import script from "./TemplatesList.vue?vue&type=script&lang=js"
export * from "./TemplatesList.vue?vue&type=script&lang=js"
import style0 from "./TemplatesList.vue?vue&type=style&index=0&id=2183d47d&prod&lang=scss&scoped=true"
import style1 from "./TemplatesList.vue?vue&type=style&index=1&id=2183d47d&prod&lang=scss"
import style2 from "./TemplatesList.vue?vue&type=style&index=2&id=2183d47d&prod&lang=scss&scoped=true"
import style3 from "./TemplatesList.vue?vue&type=style&index=3&id=2183d47d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183d47d",
  null
  
)

export default component.exports